"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jwtDecode = require("jwt-decode");
const base_64_1 = require("base-64");
const configuration_1 = require("@common/configuration");
class AuthManager {
    constructor(onError) {
        this.tokenFromAdmin = 'tokenFromAdmin';
        this.jwt = 'jwt';
        this.lastSession = 'lastSession';
        this.genericToken = 'genericToken';
        this.jwtCheckTimer = null;
        this.onError = onError ? onError : () => false;
    }
    getToken() {
        const token = window.localStorage.getItem(this.genericToken);
        if (!token && configuration_1.Configuration.localAuthToken()) {
            const localToken = configuration_1.Configuration.localAuthToken();
            return { [this.tokenFromAdmin]: localToken, [this.jwt]: localToken, [this.lastSession]: localToken };
        }
        if (!token) {
            return { [this.tokenFromAdmin]: null, [this.jwt]: null, [this.lastSession]: null };
        }
        return JSON.parse(base_64_1.decode(token));
    }
    removeToken() {
        window.localStorage.removeItem(this.genericToken);
    }
    removeTokenFromAdmin() {
        this.saveToken(null, this.tokenFromAdmin);
    }
    saveToken(token, alias) {
        if (configuration_1.Configuration.localAuthToken())
            return;
        const genericToken = this.getToken();
        genericToken[alias] = token;
        const tokenUpdated = JSON.stringify(genericToken);
        window.localStorage.setItem(this.genericToken, base_64_1.encode(tokenUpdated));
        if (alias === this.jwt) {
            this.checkJwt(tokenUpdated);
        }
    }
    getTokenFromAdmin() {
        const genericToken = this.getToken();
        return genericToken[this.tokenFromAdmin];
    }
    getInfoFromAdmin() {
        if (configuration_1.Configuration.localAdminInfo())
            return configuration_1.Configuration.localAdminInfo();
        const token = this.getTokenFromAdmin();
        if (!token) {
            return null;
        }
        return jwtDecode(token);
    }
    getJwt() {
        const genericToken = this.getToken();
        return genericToken ? genericToken[this.jwt] : null;
    }
    getLastSession() {
        const genericToken = this.getToken();
        return genericToken[this.lastSession];
    }
    checkJwt(encoded) {
        let jwt = null;
        try {
            jwt = jwtDecode(encoded);
        }
        catch (e) {
            this.jwtCheckTimer = setTimeout(() => this.onError(), 100);
            return false;
        }
        const currentTime = parseInt(Date.now().toString());
        const expiration = parseInt(jwt.exp) * 1000;
        if (currentTime > expiration)
            return this.onError();
        const timeLeft = expiration - currentTime;
        clearTimeout(this.jwtCheckTimer);
        this.jwtCheckTimer = setTimeout(() => this.onError('expiration'), timeLeft);
        return jwt;
    }
}
exports.authManager = new AuthManager();
//# sourceMappingURL=auth-manager.js.map